export const additionalDaysForUnassignmentCollectionDate = 4;

export const countriesRequiringPersonalId = ['br'];

export const specialBusiness = ['uy', 'cr'];

export const zipCodeLengthLimit = 10;

export const invalidZipCodeText = 'Código inválido';

export enum SPECIAL_BUSINESS_NAME_TYPES_ID {
  TRADING = 1,
  FREE_ZONE_URUGUAY = 2,
  FREE_ZONE_COSTA_RICA = 3
}

export const FREE_ZONE_SPECIAL_BUSINESS_NAME_TYPES = [
  SPECIAL_BUSINESS_NAME_TYPES_ID.FREE_ZONE_URUGUAY,
  SPECIAL_BUSINESS_NAME_TYPES_ID.FREE_ZONE_COSTA_RICA
];

export enum SPECIAL_BUSINESS_NAME_TYPES_DESCRIPTIONS {
  TRADING_DESCRIPTION = 'Trading - Esta razón social no puede recibir facturas de Uruguay ⚠️ ',
  FREE_ZONE_URUGUAY_DESCRIPTION = 'Zona Franca - Esta razón social no paga el impuesto de 22% ⚠️ ',
  FREE_ZONE_COSTA_RICA_DESCRIPTION = 'Zona Franca - Esta razón social no paga el impuesto de 13% ⚠️ '
}
export const getSpecialBusinessData = (
  type: 'description' | 'alert' = 'description',
  specialBusinessNameTypeId?: number
): string | undefined => {
  if (!specialBusinessNameTypeId) return undefined;
  const specialBusinessData: Record<number, { description: string | undefined; alert: string }> = {
    [SPECIAL_BUSINESS_NAME_TYPES_ID?.FREE_ZONE_URUGUAY]: {
      description: SPECIAL_BUSINESS_NAME_TYPES_DESCRIPTIONS?.FREE_ZONE_URUGUAY_DESCRIPTION,
      alert: 'Emite la factura desde Uruguay. '
    },
    [SPECIAL_BUSINESS_NAME_TYPES_ID?.FREE_ZONE_COSTA_RICA]: {
      description: SPECIAL_BUSINESS_NAME_TYPES_DESCRIPTIONS?.FREE_ZONE_COSTA_RICA_DESCRIPTION,
      alert: 'Emite la factura desde Costa Rica. '
    },
    [SPECIAL_BUSINESS_NAME_TYPES_ID?.TRADING]: {
      description: SPECIAL_BUSINESS_NAME_TYPES_DESCRIPTIONS?.TRADING_DESCRIPTION,
      alert: 'Emite la factura desde la LLC'
    }
  };
  const specialBusinessDataById = specialBusinessData[specialBusinessNameTypeId]?.[type];
  return specialBusinessDataById;
};

export const getIsInvalidZipCode = (zipCode?: string | null) => zipCode && zipCode.length > zipCodeLengthLimit;

export const validPersonalIdByCountry = (personalId: string, countryCode?: string | null) => {
  //CAMBIAR-JC: Si se agregan más países considerar agregar columnas en backend en organization.Country para los personalIds
  if (countryCode === 'br') {
    const brazileanDocumentRegex = /^(\d{3}\.){2}\d{3}-\d{2}$/g;
    return brazileanDocumentRegex.test(personalId);
  }
  return true;
};

export const validPersonalIdExampleByCountry = (countryCode?: string | null) => {
  //CAMBIAR-JC: Si se agregan más países considerar agregar columnas en backend en organization.Country para los personalIds
  if (countryCode === 'br') return '000.000.000-00';
  return;
};

export const formatZipCode = (rawZipCode?: string | null) => {
  if (!rawZipCode) return '';
  return rawZipCode.trim().replaceAll(' ', '');
};

export const FREE_ZONE_KEYWORD = 'zona_franca';

export const VAT_VALUE_BY_COUNTRY: Record<string, number> = {
  uy: 22,
  cr: 13
};
